import { render, staticRenderFns } from "./CardInvoices.vue?vue&type=template&id=4e4c9163&"
import script from "./CardInvoices.vue?vue&type=script&lang=js&"
export * from "./CardInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports